import React from 'react';
import { ReactComponent as ArrowRightIcon } from '../../assets/images/icons/arrow-right.svg';

export default function ArrowRight(props) {
  return <ArrowRightIcon className={`icon ${props.className}`} />;
}
